// extracted by mini-css-extract-plugin
module.exports = {"body":"style__body__oBoh3","top":"style__top__gYR0s","bottom":"style__bottom__QPggX"};